module.exports = __webpack_public_path__ + "static/media/project1.808dbd29.jpg";